import { Stack, Typography } from '@mui/material';
import {
  CompaniesCarousel,
  MacBookWindow,
  Section,
} from '@rumblefish/ui/Rumblefish23Theme';

export const Hero = () => {
  return (
    <>
      <MacBookWindow
        title={
          <>
            {' '}
            Experienced IT team tailored <br /> to your needs
          </>
        }
        description={
          <>
            {' '}
            Hire world-class <b>IT professionals</b> to cover your development
            needs
          </>
        }
        buttonLink="/contact"
        buttonText="Book a free consultation"
        gradient="orange-purple"
      />

      <Section width="normal">
        <Stack
          sx={(theme) => ({
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(7),
            marginTop: theme.spacing(6),
            textAlign: 'center',
            marginBottom: theme.spacing(16),
            [theme.breakpoints.down('md')]: {
              marginBottom: theme.spacing(15),
            },
            [theme.breakpoints.down('sm')]: {
              marginBottom: theme.spacing(9),
            },
          })}>
          <Typography
            sx={{
              color: (theme) => theme.palette.invertedContent?.PRIMARY,
            }}
            variant="strong_400">
            We’re a team of world-class experts in bespoke software development.
            Our engineers are highly skilled in blockchain, AI, AWS cloud
            solutions, and defi/fintech development. Our strength and pride is
            the ability to take ownership of the entire development process and
            be a true partner and advisor for our customers.
          </Typography>
          <CompaniesCarousel />
        </Stack>
      </Section>
    </>
  );
};
